module.exports = __webpack_public_path__ + "img/patientlist.7e26ecbf.svg";